import type { AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { addTestMemory, getTestLoginApi } from '@/api/authApi'
import type { TestLoginResponse } from '@/api/model/authType'

export const useTestLogin = (options: UseMutationOptions<TestLoginResponse, AxiosError, { user_id: number }>) => {
  return useMutation({
    mutationFn: ({ user_id }: { user_id: number }) => getTestLoginApi(user_id),
    ...options
  })
}

export const useAddTestMemory = (options: UseMutationOptions<string, AxiosError>) => {
  return useMutation({
    mutationFn: addTestMemory,
    ...options
  })
}
